<template>
  <div>
    <!-- form -->
    <validation-observer
      ref="newPasswordForm"
      #default="{invalid}"
    >
      <b-form
        class="auth-register-form mt-2"
        @submit.prevent="completeNewPassword()"
      >
        <!-- password -->
        <b-form-group>
          <label>New Password</label>
          <validation-provider
            #default="{ errors }"
            rules="required|password"
            name="password"
            vid="password"
          >
            <b-input-group
              class="input-group-merge"
              :class="errors.length > 0 ? 'is-invalid':null"
            >
              <b-form-input
                v-model="newPassword"
                :type="passwordFieldType"
                :state="errors.length > 0 ? false:null"
                placeholder="Password"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIcon"
                  class="cursor-pointer"
                  @click="togglePasswordVisibility"
                />
              </b-input-group-append>
            </b-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- confirm password -->
        <b-form-group>
          <label>Confirm New Password</label>
          <validation-provider
            #default="{ errors }"
            rules="required|confirmed:password"
            name="Confirm Password"
          >
            <b-input-group
              class="input-group-merge"
              :class="errors.length > 0 ? 'is-invalid':null"
            >
              <b-form-input
                v-model="newPasswordConfirm"
                :type="passwordFieldType"
                :state="errors.length > 0 ? false:null"
                placeholder="Repeat Password"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIcon"
                  class="cursor-pointer"
                  @click="togglePasswordVisibility"
                />
              </b-input-group-append>
            </b-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>

        </b-form-group>
        <b-button
          variant="primary"
          class="btn-block"
          :disabled="invalid"
          @click="completeNewPassword()"
        >
          Change Password
        </b-button>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
/* eslint-disable global-require */
/* eslint-disable no-unused-vars */
import { ref } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import {
  BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BButton, BForm,
} from 'bootstrap-vue'
import { Auth } from 'aws-amplify'

export default {
  components: {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    BButton,
    BForm,
  },
  mixins: [togglePasswordVisibility],
  props: {
    email: {
      type: String,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      verifyCode: '',
      newPassword: '',
      newPasswordConfirm: '',
      passwordFieldType: 'password',
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    async completeNewPassword() {
      try {
        await Auth.completeNewPassword(this.user, this.newPassword)
          .then(response => {
            this.$emit('login', this.newPassword)
          })
      } catch (error) {
        // console.log('error completing new password', error)
      }
    },
    validationForm() {
      this.$refs.newPasswordForm.validate().then(success => {
        if (success) {
          this.completeNewPassword()
          // console.log('success')
        }
      })
    },
  },
}
</script>

<style>

</style>
